import React from "react";
import { motion } from "framer-motion";

const METRICS = [
  { v: "+0.28s", l: "Avg 40yd Dash Improvement" },
  { v: "98%", l: "Client Retention Rate" },
  { v: "100+", l: "Athletes Coached" },
  { v: "0", l: "Gimmicks. Period." },
];

const TESTIMONIALS = [
  {
    quote:
      "Dropped my 40-time by 3 tenths in 8 weeks. The mechanics work translated instantly to the field.",
    name: "Marcus R.",
    role: "College WR · Houston",
  },
  {
    quote:
      "I travel for work and thought online training wouldn't stick. Gain Time rebuilt my hips and knees from two time zones away.",
    name: "Priya K.",
    role: "Masters Runner",
  },
  {
    quote:
      "Recovery protocols alone are worth the program. I'm 42 and training pain-free for the first time in a decade.",
    name: "Jordan T.",
    role: "Rec Athlete · Katy",
  },
];

export default function Results() {
  return (
    <section
      id="results"
      className="relative border-t border-zinc-900 py-24 md:py-32 px-6 md:px-12"
      data-testid="results-section"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#E5B43A] mb-4">
              // Results
            </div>
            <h2 className="font-display text-4xl md:text-6xl tracking-tight">
              The numbers <span className="text-[#E5B43A]">don't lie.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 border-t border-zinc-800">
          {METRICS.map((m, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="border-r border-b md:border-b-0 border-zinc-800 last:border-r-0 py-8 md:py-10 pr-6"
              data-testid={`metric-${i}`}
            >
              <div className="font-display text-5xl md:text-6xl text-white">{m.v}</div>
              <div className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-500 mt-3">
                {m.l}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative border-l-2 border-[#E5B43A] pl-6 py-2"
              data-testid={`testimonial-${i}`}
            >
              <p className="text-zinc-200 text-base leading-relaxed mb-6">"{t.quote}"</p>
              <div className="font-display text-lg tracking-wide">{t.name}</div>
              <div className="text-xs tracking-[0.2em] uppercase text-zinc-500 mt-1">
                {t.role}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
